import aashto from './Aashto/Config';
import ariz from './Ariz/Config';
import as from './As/Config';
import astm from './Astm/Config';
import bsC11 from './Bs/C11/Config';
import bsC9_2 from './Bs/C9_2/Config';

export default {
  ...astm,
  ...ariz,
  ...aashto,
  ...as,
  ...bsC11,
  ...bsC9_2,
};
